module.exports = __webpack_public_path__ + "img/session-list-banner.19941214.jpg";